import React, { useMemo, useState, useEffect, useRef } from 'react';
import '../../CustomModule.css';
import { cloneDeep, isArray } from 'lodash';
import { useTranslation } from 'react-i18next';
import { fetchColorArray, getControlStyle, matchRule, resetValueInArray } from '../../../../../Components/helper';
import { useCustomModuleState } from '../../Context/index';
import TableCoumnModal from './TableCoumnModal';
import TextInputControl from '../../../../../Components/CommonTableControls/TextInput';
import DropDownControl from '../../../../../Components/CommonTableControls/DropDown';
import MultiSelectDropdownControl from '../../../../../Components/CommonTableControls/MultiSelectDropdown';
import NumberDecimalControl from '../../../../../Components/CommonTableControls/NumberDecimal';
import TextAreaControl from '../../../../../Components/CommonTableControls/TextArea';
import DatePickerControl from '../../../../../Components/CommonTableControls/DatePickerElement';
import TimepickerControl from '../../../../../Components/CommonTableControls/Timepicker';
import SignatureControl from '../../../../../Components/CommonTableControls/Signature';
import CompanyStampControl from '../../../../../Components/CommonTableControls/CompanyStamp';
import LabelControl from '../../../../../Components/CommonTableControls/Label';
import StatusControl from '../../../../../Components/CommonTableControls/Status';
import CheckBoxControl from '../../../../../Components/CommonTableControls/CheckBox';
import RadioControl from '../../../../../Components/CommonTableControls/Radio';
import NumberPercentageControl from '../../../../../Components/CommonTableControls/NumberPercentage';
import SourceValues from '../../../../../Components/CommonTableControls/SourceComp';
import CalculationComp from '../../../../../Components/CommonTableControls/CalculationComp';
import DepndentValue from '../../../../../Components/CommonTableControls/DepndentComp';
import SignatureModal from '../../../../DevlopmentOrder/CustomModule/SignatureModal';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import { ActiveIcon, DeleteIcon, DuplicateIcon, EditIcon, AddIcon } from '../../../../../bombiix-icon';
import { BombiixAGGrid } from '../../../../../Components/BombiixAGGrid';

export function TableControl({
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  gridY,
  index,
  tableColumns,
  tableData,
  updateTableRow,
  updateTableColumData,
  labelInModal,
  updateTableRowData,
  gridH,
  handleTableTitleUpdate,
  setParentGridZIndex,
  onHeightChange,
}) {
  const { rowHeight, setCustomModuleState } = useCustomModuleState();
  const [state, setState] = useState({
    tableColumnModal: false,
    signModal: false,
    signatureIndex: null,
    isSignForTable: false,
    signatureData: null,
  });
  const { t } = useTranslation('common');
  const tableRef = useRef(null);
  const { tableColumnModal, signModal, signatureIndex, signatureData } = state;
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const contextTableColumn = tableColumns;
  const contextTableData = tableData;

  const [resizingIndex, setResizingIndex] = useState(null);
  const [resizeStartX, setResizeStartX] = useState(null);
  const [isTableUpdate, setIsTableUpdate] = useState(false);
  const isAddingRowRef = useRef(false);
  const [columnWidths, setColumnWidths] = useState(() => {
    const initialWidth = 100 / (contextTableColumn?.length || 0); // Equal initial width for each column
    return Object.fromEntries(contextTableColumn?.map((column) => [column.fieldName, column?.width || initialWidth]));
  });

  useEffect(() => {
    if (contextTableColumn?.length > 0) {
      const columnCount = contextTableColumn.length;
      const equalWidth = 100 / columnCount; // Distribute 100% equally

      // Assign equal width to all columns
      let initialWidths = Object.fromEntries(contextTableColumn.map((column) => [column.fieldName, column.width || equalWidth]));

      // Ensure total width = 100%
      const totalWidth = Object.values(initialWidths).reduce((sum, width) => sum + width, 0);

      if (totalWidth !== 100) {
        const scaleFactor = 100 / totalWidth; // Adjust proportionally
        initialWidths = Object.fromEntries(Object.entries(initialWidths).map(([key, width]) => [key, width * scaleFactor]));
      }
      setColumnWidths(initialWidths);
    }
  }, [contextTableColumn?.length]);

  useEffect(() => {
    if (contextTableColumn?.length > 0) {
      // Map updated column widths to the existing table columns
      const updatedColumns = contextTableColumn.map((col) => ({
        ...col,
        width: columnWidths[col.fieldName], // Apply the new width from columnWidths state
      }));
      // Update table column data
      updateTableColumData(updatedColumns, gridIndex);
    }
  }, [columnWidths]);

  const handleMouseDown = (indexTr, event) => {
    setResizingIndex(indexTr);
    setResizeStartX(event.clientX);
  };

  const handleMouseMove = (event) => {
    if (resizingIndex !== null) {
      const newWidths = { ...columnWidths };
      const column = contextTableColumn[resizingIndex];

      const deltaX = event.clientX - resizeStartX;
      let newWidth = newWidths[column.fieldName] + (deltaX / window.innerWidth) * 100;

      // Ensure minimum column width (e.g., 5%) to prevent collapse
      newWidth = Math.max(5, newWidth);

      // Compute the difference
      const widthDiff = newWidth - newWidths[column.fieldName];
      newWidths[column.fieldName] = newWidth;

      // Adjust other columns dynamically
      const remainingColumns = contextTableColumn.filter((_, index) => index !== resizingIndex);
      const totalRemainingWidth = remainingColumns.reduce((sum, col) => sum + newWidths[col.fieldName], 0);

      if (totalRemainingWidth - widthDiff < 5 * remainingColumns.length) {
        return; // Prevent shrinking too much
      }

      remainingColumns.forEach((col) => {
        newWidths[col.fieldName] -= (widthDiff / totalRemainingWidth) * newWidths[col.fieldName];
      });

      // Ensure total width remains ≤ 100
      const totalWidth = Object.values(newWidths).reduce((sum, width) => sum + width, 0);
      if (totalWidth > 100) {
        return;
      }

      setColumnWidths(newWidths);
      setResizeStartX(event.clientX);

      const updatedWidthData = contextTableColumn.map((item) => ({
        ...item,
        width: newWidths[item.fieldName],
      }));

      updateTableColumData(updatedWidthData, gridIndex);
    }
  };

  const handleCloseSignature = () => {
    setState((previosState) => ({
      ...previosState,
      signModal: false,
      isSignForTable: false,
    }));
  };
  const handleMouseUp = () => {
    setResizingIndex(null);
  };

  const handleAddEditColumn = () => {
    setState((prevState) => ({
      ...prevState,
      tableColumnModal: true,
    }));
    setCustomModuleState((prevState) => ({
      ...prevState,
      disableDrag: true,
    }));
  };
  const handleCloseTableColumn = () => {
    setState((prevState) => ({
      ...prevState,
      tableColumnModal: false,
    }));
    setCustomModuleState((prevState) => ({
      ...prevState,
      disableDrag: false,
    }));
  };
  const handleAddColumnInSection = () => {
    const contextTableDataCopy = cloneDeep(contextTableData);

    // Deep copy of contextTableColumn
    const copyTableColumn = cloneDeep(contextTableColumn);
    if (contextTableDataCopy.length > 0) {
      const result = contextTableDataCopy.map((rowData) =>
        copyTableColumn.map((colDefinition) => {
          const cell = rowData.find((cell1) => {
            return cell1.fieldName === colDefinition?.fieldName && cell1?.key === colDefinition?.key;
          });
          let optionsList = [];
          let checkRadioUpdateOption = [];
          let colourList = [];
          let defaultColorOption = [];
          switch (cell?.key) {
            case 'Text':
            case 'Text_Area':
            case 'Time_Picker':
              return { ...cell };
            case 'Date_Picker':
              return { ...cell, range: colDefinition?.range || false };
            case 'Check_Boxes':
            case 'Ratio_Button':
              optionsList = cell?.options;
              checkRadioUpdateOption =
                isArray(optionsList) &&
                optionsList
                  ?.map((item1) => {
                    const matchingItem = isArray(colDefinition?.options) && colDefinition?.options?.find((item2) => item1?.id === item2?.id);
                    return matchingItem ? { ...item1, label: matchingItem?.label, value: matchingItem?.value } : null;
                  })
                  ?.filter((item) => item !== null)
                  ?.concat(colDefinition?.options?.filter((item2) => !optionsList.some((item1) => item1?.id === item2?.id)));
              return {
                ...cell,
                options: checkRadioUpdateOption,
              };
            case 'Status':
              colourList = cell?.statusColours;
              defaultColorOption =
                isArray(colourList) &&
                colourList?.map((status1, indexColor) => ({
                  colourName: colDefinition?.statusColours[indexColor]?.colourName,
                  colourHexCode: colDefinition?.statusColours[indexColor]?.colourHexCode,
                  setDefault: status1?.setDefault || colDefinition?.statusColours[indexColor]?.setDefault,
                }));
              return {
                ...cell,
                statusColours: defaultColorOption,
              };
            case 'Number_Percentage':
            case 'Number_Decimal':
              return { ...cell, colourArray: colDefinition?.colourArray };
            case 'Dropdown':
            case 'Multi_Dropdown':
              return { ...cell, options: colDefinition?.options };
            case 'Label':
              return { ...cell, labelColours: colDefinition?.labelColours };
            case 'Company_Stamp':
              return { ...cell, companyLogo: colDefinition?.companyLogo };
            case 'Signature':
              return { ...cell, fontFamily: colDefinition?.fontFamily };
            case 'Dependent':
              return { ...cell, relation: { ...cell.relation, isContentArr: colDefinition?.relation?.isContentArr } };
            default:
              return { ...colDefinition };
          }
        }),
      );

      updateTableRowData(result, gridIndex);
    } else if (copyTableColumn.length > 0) updateTableRowData(copyTableColumn, gridIndex, true);

    setState((prevState) => ({
      ...prevState,
      tableColumnModal: false,
    }));
    setCustomModuleState((prevState) => ({
      ...prevState,
      disableDrag: false,
    }));
  };
  const combinedStyles = getControlStyle(otherConfiguration);

  function calculateIsChecked(option, checkRadioValue, value, controlKey) {
    if (option.name === checkRadioValue) {
      return value;
    }
    if (controlKey === 'Ratio_Button') {
      return false;
    }
    return option.isChecked;
  }

  const updateDependentRelation = (item, selectedControl) => {
    const relationControl = item?.relation?.dropDownControl?.control;
    if (relationControl?.fieldName === selectedControl?.fieldName && relationControl?.key === selectedControl?.key) {
      if (item?.relation?.fixed) {
        const replaceValue = item?.relation?.isContentArr?.find(
          (ele) => ele?.isContent?.label === selectedControl?.value?.label && ele?.isContent?.value === selectedControl?.value?.value,
        );
        item.relation.value = replaceValue?.to || '';
      }
    }
  };

  const onHeightChangeInsideTable = () => {
    setIsTableUpdate(!isTableUpdate);
  };

  const handleOnChangeControl = async (value, rowInd, colInd, checkRadioValue) => {
    const moduleDataCopy = cloneDeep(contextTableData);
    const rowData = moduleDataCopy?.[rowInd];
    const selectedControl = rowData[colInd];
    const updatedControl = { ...selectedControl, value };
    switch (selectedControl.key) {
      case 'Check_Boxes':
      case 'Ratio_Button': {
        updatedControl.options = selectedControl.options.map((option) => ({
          ...option,
          isChecked: calculateIsChecked(option, checkRadioValue, value, selectedControl.key),
        }));
        break;
      }
      case 'Number_Percentage':
      case 'Number_Decimal': {
        if (!selectedControl?.colourArray) {
          selectedControl.colourArray = [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ];
        }
        const newArray = await fetchColorArray(selectedControl.colourArray);
        const matchingRule = newArray.find((rule) => matchRule(rule, value));
        updatedControl.textColour = matchingRule ? matchingRule.colourType : null;
        break;
      }
      default:
        // Add default case here
        break;
    }

    const hasDependent = rowData?.find((item) => item?.key === 'Dependent');
    if (hasDependent) {
      updateDependentRelation(rowData, selectedControl);
      moduleDataCopy[rowInd] = rowData;
    }
    rowData[colInd] = updatedControl;

    updateTableRow(rowData, gridIndex, rowInd);
  };

  const handleSign = (rowInd, colInd) => {
    const obj = {
      gridIndex,
      pageIndex,
      rowInd,
      colInd,
    };

    const gridTableArray = [...(tableData || [])];

    setState((previosState) => ({
      ...previosState,
      signModal: true,
      signatureIndex: obj,
      isSignForTable: true,
      signatureData: gridTableArray[rowInd][colInd],
    }));
  };

  const handleConfirmSignature = (data) => {
    const moduleDataCopy = cloneDeep(contextTableData);
    const rowData = moduleDataCopy?.[signatureIndex.rowInd];
    rowData[signatureIndex.colInd] = data;

    updateTableRow(rowData, gridIndex, signatureIndex.rowInd);
    handleCloseSignature();
  };

  const getSettings = (contrlData) => {
    const matchColData = contextTableColumn.find((ele) => ele?.fieldName === contrlData?.fieldName && ele?.key === contrlData?.key);
    return matchColData?.otherConfiguration;
  };
  const getFonts = (contrlData) => {
    const matchColData = contextTableColumn.find((ele) => ele?.fieldName === contrlData?.fieldName && ele?.key === contrlData?.key);
    return matchColData?.fontSize;
  };

  const handleCalendarOpen = () => {
    setParentGridZIndex(true, gridIndex);
  };

  const handleCalendarClose = () => {
    setParentGridZIndex(false, gridIndex);
  };
  const renderControl = (controlDetail, rowIndex, colIndex) => {
    const otherConfig = getSettings(controlDetail);
    const fontSize = getFonts(controlDetail);
    switch (controlDetail.key) {
      case 'Text':
        return (
          <TextInputControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            charCount={false}
            otherConfiguration={otherConfig}
          />
        );

      case 'Dropdown':
        return <DropDownControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} gridY={gridY} />;

      case 'Multi_Dropdown':
        return <MultiSelectDropdownControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} gridY={gridY} />;

      case 'Number_Decimal':
        return (
          <NumberDecimalControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            charCount={false}
            maxCount={20}
            otherConfiguration={otherConfig}
          />
        );
      case 'Text_Area':
      case 'Paragraph':
        return (
          <TextAreaControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            charCount={false}
            maxCount={1000}
            otherConfiguration={otherConfig}
            fontSize={fontSize}
            onHeightChange={onHeightChangeInsideTable}
            fromLibrary
          />
        );

      case 'Date_Picker':
        return (
          <DatePickerControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            handleCalendarOpen={handleCalendarOpen}
            handleCalendarClose={handleCalendarClose}
          />
        );

      case 'Time_Picker':
        return <TimepickerControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} />;

      case 'Signature':
        return (
          <SignatureControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            handleUpdateSignature={handleSign}
            fromProduct
          />
        );

      case 'Company_Stamp':
        return <CompanyStampControl {...controlDetail} />;

      case 'Label':
        return <LabelControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} />;

      case 'Status':
        return <StatusControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} gridY={gridY} />;

      case 'Check_Boxes':
        return <CheckBoxControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} tableIndex={gridIndex} />;

      case 'Ratio_Button':
        return <RadioControl {...controlDetail} onChange={handleOnChangeControl} rowIndex={rowIndex} colIndex={colIndex} tableIndex={gridIndex} />;

      case 'Number_Percentage':
        return (
          <NumberPercentageControl
            {...controlDetail}
            onChange={handleOnChangeControl}
            rowIndex={rowIndex}
            colIndex={colIndex}
            charCount={false}
            maxCount={10}
            otherConfiguration={otherConfig}
          />
        );
      case 'Source':
        return <SourceValues {...controlDetail} rowIndex={rowIndex} colIndex={colIndex} gridIndex={gridIndex} pageIndex={pageIndex} />;
      case 'Calculation':
        return (
          <CalculationComp
            {...controlDetail}
            rowIndex={rowIndex}
            colIndex={colIndex}
            gridIndex={gridIndex}
            pageIndex={pageIndex}
            otherConfiguration={otherConfig}
          />
        );
      case 'Dependent':
        return <DepndentValue {...controlDetail} />;

      default:
        break;
    }
  };

  const handleAddRow = (rowIndex) => {
    isAddingRowRef.current = true;

    const gridHeight = gridH * rowHeight;
    const tableId = `table_control_${pageIndex}_${gridIndex}`;
    const tableElement = document.getElementById(tableId);
    // 40 is Required Row Height & 18 is table title height
    const reqTableHeight = tableElement.clientHeight + 20 + 18;
    if (gridHeight < reqTableHeight) {
      toasterMsg(t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_CONTROL.ADD_ROW_VALIDATION'), 'danger');
      isAddingRowRef.current = false;
      return;
    }
    // Deep copy of the specific row data at rowIndex
    const rowDataCopy = cloneDeep(contextTableData[rowIndex]);

    updateTableRowData([...contextTableData, rowDataCopy], gridIndex);

    // Reset the flag after a short delay to allow the update to complete
    setTimeout(() => {
      isAddingRowRef.current = false;
    }, 100);
  };

  const handleDeleteRow = (rowIndex) => {
    const tableDataCopy = tableData;

    if (tableDataCopy.length === 1) {
      // If it's the last row, reset its values instead of deleting
      tableDataCopy[0] = resetValueInArray(tableDataCopy[0]);
    } else {
      // Otherwise, delete the row
      tableDataCopy.splice(rowIndex, 1);
    }

    updateTableRowData(tableDataCopy, gridIndex);
  };

  const updateTableColumns = (data) => {
    updateTableColumData(data, gridIndex);
  };
  const handleTableTitle = (value) => {
    handleTableTitleUpdate(value, gridIndex);
  };

  useEffect(() => {
    if (isTableUpdate && tableRef.current && !isAddingRowRef.current) {
      const tableElement = tableRef.current;
      const tableHeight = tableElement.clientHeight;
      if (tableHeight > 0) {
        labelInModal ? onHeightChange(tableHeight + 30) : onHeightChange(tableHeight + 4);
      }
    }
  }, [isTableUpdate]);
  /** One grid row per table row; cells are rendered by the existing control renderer. */
  const gridRowData = useMemo(() => (contextTableData || []).map((_row, rowIndex) => ({ id: rowIndex, __rowIndex: rowIndex })), [contextTableData]);

  const gridColumnDefs = useMemo(() => {
    const cols = (contextTableColumn || []).map((col, colIndex) => ({
      colId: `col-${colIndex}`,
      headerName: col?.fieldName || '',
      cellRenderer: (params) => {
        const rowIndex = params?.data?.__rowIndex ?? 0;
        const cell = (contextTableData?.[rowIndex] || []).find((c) => c?.fieldName === col?.fieldName && c?.key === col?.key);
        return cell ? renderControl(cell, rowIndex, colIndex) : null;
      },
    }));
    return [
      ...cols,
      {
        colId: 'row-actions',
        headerName: '',
        width: 100,
        pinned: 'right',
        cellRenderer: (params) => {
          const rowIndex = params?.data?.__rowIndex ?? 0;
          return (
            <div className="d-flex align-items-center h-100">
              <button type="button" onClick={() => handleDeleteRow(rowIndex)} className="btn d-flex px-1">
                <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_CONTROL.DELETE')}</span>
                <DeleteIcon size={24} />
              </button>
              <button type="button" onClick={() => handleAddRow(rowIndex)} className="btn d-flex px-1">
                <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_CONTROL.ADD')}</span>
                <AddIcon size={24} />
              </button>
            </div>
          );
        },
      },
    ];
  }, [contextTableColumn, contextTableData, renderControl, handleDeleteRow, handleAddRow, t]);

  return (
    <>
      <div className="position-relative h-100" style={{ borderBottom: 'solid 1px #848484' }}>
        {labelInModal && <p className="text-left mb-1 f-13 font-medium">{labelInModal}</p>}

        <div style={combinedStyles}>
          {contextTableData?.length > 0 && (
            <div className="resizable-table table-action-hover">
              <BombiixAGGrid rowData={gridRowData} columnDefs={gridColumnDefs} getRowId={(row) => row['id']} />
            </div>
          )}
        </div>
        {fromForm && onElement && (
          <div className="potemp-action-btns placement-bottom">
            <button aria-label="Edit" type="button" className="btn btn-border ml-auto py-0 px-1" onClick={() => handleAddEditColumn()}>
              <EditIcon size={24} />
            </button>

            <button aria-label="Copy" type="button" className="btn btn-border py-0 px-1" onClick={() => handleDuplicateItem()}>
              <DuplicateIcon size={24} />
            </button>
            <button
              aria-label="Active/Inactive Supplier"
              type="button"
              className={`btn btn-border py-0 px-1 ${supplierVisible ? 'text-success' : 'text-danger'}`}
              onClick={() => handleSupplierPermission(gridIndex, pageIndex)}
            >
              <ActiveIcon size={24} />
            </button>
            {showDelete && (
              <button aria-label="Delete" type="button" className="btn btn-border py-0 px-1" onClick={() => deleteItem(gridIndex, pageIndex)}>
                <DeleteIcon size={24} />
              </button>
            )}
            <button
              aria-label="Static"
              type="button"
              className={`btn btn-border py-0 px-1 ${isStatic && 'text-danger'}`}
              onClick={() => handleStaticGrid(gridIndex, pageIndex)}
            >
              <span className="icon-lock" />
            </button>
          </div>
        )}
      </div>
      {tableColumnModal && (
        <TableCoumnModal
          show={tableColumnModal}
          handleClose={handleCloseTableColumn}
          tableColumns={tableColumns}
          handleAddColumnInSection={handleAddColumnInSection}
          i={index}
          updateTableColumns={updateTableColumns}
          labelInModal={labelInModal}
          handleTableTitle={handleTableTitle}
        />
      )}
      {signModal && <SignatureModal onOpen={signModal} signatureData={signatureData} onConfirm={handleConfirmSignature} toggle={handleCloseSignature} />}
    </>
  );
}
export default TableControl;
